'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var batch = require('it-batch');

function parallelBatch(_x, _x2) {
  return _parallelBatch.apply(this, arguments);
}

function _parallelBatch() {
  _parallelBatch = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, size) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, things, i, _yield$_awaitAsyncGen, res, _err;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            size = parseInt(size);

            if (isNaN(size) || size < 1) {
              size = 1;
            }

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 4;
            _iterator = _asyncIterator(batch(source, size));

          case 6:
            _context.next = 8;
            return _awaitAsyncGenerator(_iterator.next());

          case 8:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 12;
            return _awaitAsyncGenerator(_step.value);

          case 12:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 33;
              break;
            }

            things = _value;
            things = things.map(function (p) {
              return p().then(function (res) {
                return {
                  res: res
                };
              }, function (err) {
                return {
                  err: err
                };
              });
            });
            i = 0;

          case 17:
            if (!(i < things.length)) {
              _context.next = 30;
              break;
            }

            _context.next = 20;
            return _awaitAsyncGenerator(things[i]);

          case 20:
            _yield$_awaitAsyncGen = _context.sent;
            res = _yield$_awaitAsyncGen.res;
            _err = _yield$_awaitAsyncGen.err;

            if (!_err) {
              _context.next = 25;
              break;
            }

            throw _err;

          case 25:
            _context.next = 27;
            return res;

          case 27:
            i++;
            _context.next = 17;
            break;

          case 30:
            _iteratorNormalCompletion = true;
            _context.next = 6;
            break;

          case 33:
            _context.next = 39;
            break;

          case 35:
            _context.prev = 35;
            _context.t0 = _context["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 39:
            _context.prev = 39;
            _context.prev = 40;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 44;
              break;
            }

            _context.next = 44;
            return _awaitAsyncGenerator(_iterator.return());

          case 44:
            _context.prev = 44;

            if (!_didIteratorError) {
              _context.next = 47;
              break;
            }

            throw _iteratorError;

          case 47:
            return _context.finish(44);

          case 48:
            return _context.finish(39);

          case 49:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 35, 39, 49], [40,, 44, 48]]);
  }));
  return _parallelBatch.apply(this, arguments);
}

module.exports = parallelBatch;